/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getGroupedConversations({ groupBy } = { groupBy: 'assignee_id' }) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy },
    });
  }

  getConversationDrillDown({
    metricType,
    assigneeId,
    conversationStatus,
    teamId,
    since,
    until,
    page = 1,
  } = {}) {
    return axios.get(`${this.url}/conversation_drill_down`, {
      params: {
        metric_type: metricType,
        assignee_id: assigneeId,
        conversation_status: conversationStatus,
        team_id: teamId,
        since,
        until,
        page,
        per_page: 10,
      },
    });
  }

  getNewOverviewMetrics() {
    return axios.get(`${this.url}/new_overview_metrics`);
  }

  getOperationalPerformanceMetrics(params = {}) {
    return axios.get(`${this.url}/operational_performance_metrics`, { params });
  }

  getBotPerformanceMetrics(params = {}) {
    return axios.get(`${this.url}/bot_performance_metrics`, { params });
  }
}

export default new LiveReportsAPI();
